import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import styles from './style';
import Overview from './Overview';
import Box from '../../../../components/atomic/Box';
import Route from '../../../../components/atomic/Route';
import Hidden from '../../../../components/atomic/Hidden';
import PageLayout from '../../../../components/layouts/WithHeader';
import { acSetDocumentSearchText } from '../../../../store/actions/documents';
import { ErrorMessage } from './ErrorMessage';
import PropertyFinancials from '../PropertyFinancials';
import { getUserTransactions } from '../../../../api/boligmappaPlus';
import { acSetUserTransactions } from '../../../../store/actions/userTransactions';
import { sGetDocumentsToSigned } from '../../../../store/reducers/properties';
import MarketingConsentDialog from './MarketingConsentDialog';
import localStorage from '../../../../utils/localStorage';

export const Home = ({
  documentsToSigned,
  fetchingProperties,
  fetchingPropertiesError,
  setSearchText,
  setUserTransactions,
}) => {
  const match = useRouteMatch();
  const financialsUrl = `${match.url}/financials`;

  useEffect(() => {
    setSearchText('');
  }, []);

  const fetchUserTransactions = async () => {
    const [error, response] = await getUserTransactions();
    if (!error && response) {
      setUserTransactions(response.responses);
    }
  };
  useEffect(() => {
    fetchUserTransactions();
  }, []);

  const [
    isConsentRequestDialogSeenStorage,
    setIsConsnetRequestDialogSeenStorage,
  ] = useState(localStorage.get('consentRequestSeen'));

  const onConsentRequestDialogClose = () => {
    localStorage.set('consentRequestSeen', true);
    setIsConsnetRequestDialogSeenStorage(true);
  };

  if (fetchingPropertiesError) {
    return <ErrorMessage fetchingPropertiesError={fetchingPropertiesError} />;
  }

  return (
    <>
      <PageLayout
        minFullHeight
        homeLayout
        fetchingProperties={fetchingProperties}
        fetchingPropertiesError={fetchingPropertiesError}
      >
        {fetchingPropertiesError && (
          <ErrorMessage fetchingPropertiesError={fetchingPropertiesError} />
        )}
        {!fetchingPropertiesError && (
          <Hidden mdUp>
            <Route exact path={match.url}>
              <Box p={1}>
                <Overview documentsToSigned={documentsToSigned} />
              </Box>
            </Route>

            <Route exact path={financialsUrl}>
              <PropertyFinancials />
            </Route>
          </Hidden>
        )}
        {/* Desktop only */}
        <Hidden smDown>
          {!fetchingPropertiesError && (
            <Box>
              <Overview documentsToSigned={documentsToSigned} />
            </Box>
          )}
          {fetchingPropertiesError && (
            <ErrorMessage fetchingPropertiesError={fetchingPropertiesError} />
          )}
        </Hidden>
      </PageLayout>
      {!isConsentRequestDialogSeenStorage && (
        <MarketingConsentDialog
          isOpen={!isConsentRequestDialogSeenStorage}
          onClose={onConsentRequestDialogClose}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  documentsToSigned: sGetDocumentsToSigned(state),
});

const mapDispatchToProps = (dispatch) => ({
  setSearchText: (searchText) => dispatch(acSetDocumentSearchText(searchText)),
  setUserTransactions: (userTransactions) =>
    dispatch(acSetUserTransactions(userTransactions)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Home));
